<template>
  <div>
    <DataTable :options="options"
               :params="{ flag: 'not_active' }"
               module="warehouse"/>
    <StocksModal/>
  </div>
</template>

<script setup>
import DataTable from "../../parts/general/DataTable"
import options from "../../../data/warehouse/materialstock"
import StocksModal from "@/components/parts/warehouse/StocksModal"
import {useStore} from "vuex"
import {getCurrentInstance, onBeforeMount, onBeforeUnmount, onMounted, ref} from "vue"
import {useHead} from "@unhead/vue"

const store = useStore()
let i18n = null
const title = ref('')

useHead({
  title: () => title.value,
})

onBeforeMount(() => {
  i18n = (getCurrentInstance())?.ctx?.$i18n
  title.value = i18n.t('stocks_archive')
})

onMounted(() => {
  store.commit('setEloquentOptions', options)
  store.commit('setAdditionalParams', { flag: 'not_active' })
})

onBeforeUnmount(() => {
  store.commit('setAdditionalParams', {})
})
</script>
